import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  Center,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useAuth } from "@/lib/auth";
import { ThemeSwitch } from "@/components/ThemeSwitch";

interface LoginForm {
  login: string;
  password: string;
}

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<LoginForm>({
    initialValues: { login: "", password: "" },
    validate: {
      login: (v) => (v.trim() ? null : "Логин обязателен"),
      password: (v) => (v.length >= 1 ? null : "Пароль обязателен"),
    },
  });

  const handleSubmit = async (values: LoginForm) => {
    setSubmitting(true);
    try {
      await login(values);
      const redirectTo =
        (location.state as { from?: string } | null)?.from ?? "/";
      navigate(redirectTo, { replace: true });
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { error?: { message?: string } } } })
          ?.response?.data?.error?.message ?? "Ошибка авторизации";
      notifications.show({
        title: "Не удалось войти",
        message: msg,
        color: "red",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Center mih="100vh">
      <Card withBorder shadow="md" p="xl" radius="md" style={{ width: 380 }}>
        <Stack gap="md">
          <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Title order={2}>EuroMarket</Title>
            <ThemeSwitch />
          </Box>
          <Text c="dimmed" size="sm">
            Введите учётные данные
          </Text>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack gap="md">
              <TextInput
                label="Логин"
                placeholder="admin"
                {...form.getInputProps("login")}
              />
              <PasswordInput
                label="Пароль"
                placeholder="********"
                {...form.getInputProps("password")}
              />
              <Button type="submit" loading={submitting} fullWidth>
                Войти
              </Button>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Center>
  );
}
